<template>
  <div class="task-overview-settings__settings">
    <div class="task-overview-settings__settings-container">
      <h2 class="marg-1-bottom">1. Skjul antal timer tildelt på visse opgaver</h2>
      <div class="do-modal__body">
        <div class="d-explainer-box text-explainer text-explainer__error">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-help">
            <path class="primary" d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/>
            <path class="secondary"
                  d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"/>
          </svg>
          Aktivér denne indstilling for at skjule timepuljen for alle opgaver med mindre end et bestemt antal timer
          (f.eks. 60 timer) for alle andre end administratorer. Selve opgaverne vil stadig være synlige for lærerne, men
          de vil ikke kunne se det specifikke antal timer, der er allokeret til dem.
        </div>
        <div class="d-label-and-toggle" @click.stop="setIsActive">
          <label class="d-label color-dark">Skjul timepuljer</label>
          <div class="do-switch" :class="{'do-switch--active': isActive}"></div>
        </div>
        <div v-if="isActive">
          <div class="prep-factor-input marg-1-bottom">
            <p class="italic">Indtast det antal timer, hvor timepuljen på opgaver skal skjules</p>
            <input type="number" v-model="thresholdToHideTaskHours" @blur="onSave" @keyup.enter="onSave" ref="the_input_field"/>
          </div>
        </div>

      </div>
    </div>
    <div class="task-overview-settings__settings-container">
      <h2>2. Visning af fordeling af puljer</h2>
      <h4 class="italic marg-1-bottom">Fordelingen er med til at give medarbejdere et overblik over deres arbejdstid og
        puljer herunder som f.eks. undervisning.
        Visse felter vises kun, hvis brugeren har fået tidelt timer timer i puljen f.eks. SFO.</h4>
      <div class="d-table__container">
        <table class="d-table marg-1-bottom d-table__overview">
          <thead>
          <tr>
            <th>Vis</th>
            <th><h4>Standardpuljer</h4></th>
            <th class="is-number"></th>
            <th class="is-number">Tildelt</th>
            <th class="is-number">Skemalagt</th>
            <th class="is-number">Forskel</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="td-toggler" @click.stop="toggleSettings('work_hours')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('work_hours')"></AppToggle>
              </div>
            </td>
            <td>Arbejdstid</td>
            <td class="is-number">100%</td>
            <td class="is-number">
              1642.8
            </td>
            <td class="is-number">1586</td>
            <td class="is-number" style="background-color: rgba(62, 207, 142, 0.57);">56.8</td>
          </tr>
          <tr>
            <td>
              <div class="td-toggler" @click.stop="toggleSettings('teaching')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('teaching')"></AppToggle>
              </div>
            </td>
            <td>Undervisning</td>
            <td class="is-number">49%</td>
            <td class="is-number">800</td>
            <td class="is-number">693.88</td>
            <td class="is-number" style="background-color: rgb(62, 207, 142);">106.13</td>
          </tr>
          <tr>
            <td>
              <div class="td-toggler" @click.stop="toggleSettings('tasks')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('tasks')"></AppToggle>
              </div>
            </td>
            <td>Øvrige Opgaver</td>
            <td class="is-number">24%</td>
            <td class="is-number">400</td>
            <td class="is-number">2</td>
            <td class="is-number">398</td>
          </tr>
          <tr>
            <td>
              <div @click.stop="toggleSettings('preparation')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('preparation')"></AppToggle>
              </div>
            </td>
            <td>Forberedelse</td>
            <td class="is-number">24%</td>
            <td class="is-number">400</td>
            <td class="is-number">0</td>
            <td class="is-number">400</td>
          </tr>
          <tr>
            <td>
              <div @click.stop="toggleSettings('pool')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('pool')"></AppToggle>
              </div>
            </td>
            <td>Lokalpulje</td>
            <td class="is-number">5%</td>
            <td class="is-number">80</td>
            <td class="is-number">0</td>
            <td class="is-number" style="background-color: rgba(62, 207, 142, 0.8);">80</td>
          </tr>
          <tr>
            <td>
              <div @click.stop="toggleSettings('substitute_hours')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('substitute_hours')"></AppToggle>
              </div>
            </td>
            <td>Vikartimer</td>
            <td class="is-number">1%</td>
            <td class="is-number">20</td>
            <td class="is-number">3</td>
            <td class="is-number" style="background-color: rgba(62, 207, 142, 0.17);">17</td>
          </tr>
          <tr>
            <td>
              <div @click.stop="toggleSettings('teaching_and_sub')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('teaching_and_sub')"></AppToggle>
              </div>
            </td>
            <td>Undervisning + Vikartimer (UV-timer)</td>
            <td class="is-number"></td>
            <td class="is-number">820</td>
            <td class="is-number">696.88</td>
            <td class="is-number" style="background-color: rgb(62, 207, 142);">123.12</td>
          </tr>
          <tr>
            <td>
              <div @click.stop="toggleSettings('club')">
                <AppToggle :allowChanges="false" :propOn="getIsOn('club')"></AppToggle>
              </div>
            </td>
            <td>
              <span class="d-badge d-badge--warning">SFO</span>
            </td>
            <td class="is-number">3%</td>
            <td class="is-number">57.2</td>
            <td class="is-number"></td>
            <td class="is-number"></td>
          </tr>
          <tr>
            <td colspan="4"><b>Vis optælling fra egne kategorier</b></td>
          </tr>
          <tr v-for="taskCategory in taskCategories" :key="taskCategory.id">
            <td>
              <div class="td-toggler" @click.stop="toggleOwnPool(taskCategory.name)">
                <AppToggle :allowChanges="false" :propOn="getIsOwnPoolOn(taskCategory.name)"></AppToggle>
              </div>
            </td>
            <td>{{ taskCategory.name}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import AppToggle from '../common/AppToggle.vue'
import eventbus from '../../eventbus'

export default {
  components: {AppToggle},
  props: {
    taskCategories: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isOn: true,
      schoolSettingsKey: 'hiddenTaskDistributionCategories',
      schoolSettingsKey2: 'shownOwnPools',
      isActive: false,
      thresholdToHideTaskHours: 0
    }
  },
  computed: {
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    hiddenTaskDistributionCategories () {
      return this.$store.getters.hiddenTaskDistributionCategories
    },
    schoolThresholdToHideTaskHours () {
      return this.schoolSettings && this.schoolSettings['thresholdToHideTaskHours'] ? this.schoolSettings['thresholdToHideTaskHours'] : null
    },
    schoolSettingShownOwnPools () {
      return this.$store.getters.shownOwnPools
    }
  },
  methods: {
    setIsActive () {
      this.isActive = !this.isActive
      if (!this.isActive) {
        this.thresholdToHideTaskHours = 0
        this.onSave()
      } else {
        this.$nextTick(_ => {
          this.$refs.the_input_field.focus()
        })
      }
    },
    onSave () {
      const key = 'thresholdToHideTaskHours'
      if (!this.isActive) {
        this.$store.dispatch('deleteSchoolSetting', key)
      } else {
        const val = this.thresholdToHideTaskHours * 1
        if (isNaN(Number(val))) {
          eventbus.toast = {text: 'Kan ikke gemme. Skal være et tal', 'success': false}
          return
        }
        this.$store.dispatch('updateSchoolSettings', {'thresholdToHideTaskHours': val})
      }
    },
    getIsOn (setting) {
      return !this.hiddenTaskDistributionCategories.includes(setting)
    },
    getIsOwnPoolOn (settingId) {
      return this.schoolSettingShownOwnPools.includes(settingId)
    },
    setIsOn () {
      this.isOn = !this.isOn
    },
    toggleSettings (setting) {
      const arr = [...this.hiddenTaskDistributionCategories] // Opret ny kopi af arrayet
      const index = arr.indexOf(setting)

      if (index !== -1) {
        arr.splice(index, 1) // Fjern setting, hvis den findes
      } else {
        arr.push(setting) // Tilføj setting, hvis den ikke findes
      }

      if (arr.length > 0) {
        this.$store.dispatch('updateSchoolSettings', {[this.schoolSettingsKey]: arr})
      } else {
        if (this.schoolSettings[this.schoolSettingsKey]) {
          this.$store.dispatch('deleteSchoolSetting', this.schoolSettingsKey) // Send string i stedet for array
        }
      }
    },
    toggleOwnPool (setting) {
      const arr = [...this.schoolSettingShownOwnPools] // Opret ny kopi af arrayet
      const index = arr.indexOf(setting)

      if (index !== -1) {
        arr.splice(index, 1) // Fjern setting, hvis den findes
      } else {
        arr.push(setting) // Tilføj setting, hvis den ikke findes
      }

      if (arr.length > 0) {
        this.$store.dispatch('updateSchoolSettings', {[this.schoolSettingsKey2]: arr})
      } else {
        if (this.schoolSettings[this.schoolSettingsKey2]) {
          this.$store.dispatch('deleteSchoolSetting', this.schoolSettingsKey2) // Send string i stedet for array
        }
      }
    }
  },
  mounted () {
    if (this.schoolThresholdToHideTaskHours) {
      this.isActive = true
      this.thresholdToHideTaskHours = this.schoolThresholdToHideTaskHours
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.task-overview-settings__settings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  margin-right: 1rem;
}

.task-overview-settings__settings-container {
  background: #fff;
  border: 1px solid #e2e8f0;
  padding: 1rem;
  border-radius: 4px;
}

.d-input-group--toggler {
  display: inline-flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-table__container {
  background: #fff;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table__overview tbody tr {
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.d-table tr td:first-child {
  padding-left: 2rem;
}

.is-number {
  text-align: right;
}


.d-table__overview tbody tr {
  border: 1px solid #e2e8f0;
}

.d-table__overview tbody tr:nth-child(even) {
  background-color: #f8fafb;
}

.d-table__overview tbody tr td {
  padding: 0.25rem;
}

.d-table__overview tbody tr td:first-child {
  padding: 0.25rem;
}

.d-table__overview tbody tr td:nth-child(4) {
  padding-right: 1rem;
}

.d-table__subjects__user tbody tr:nth-child(even) {
  background-color: #f8fafb;
}

.d-table__subjects__user thead th:first-child,
.d-table__subjects__user tbody td:first-child {
  max-width: 300px;
  width: 20%
}

.d-table tbody td:nth-child(2) {
  width: 50%;
}

.d-table tbody td:nth-child(3),
.d-table tbody td:nth-child(4),
.d-table tbody td:nth-child(5) {
  width: 10%;
}

.d-bagde.d-badge--warning {
  border-radius: 4px;
  background-color: #fef3f2;
  border: 1px solid #fbdfde;
  color: #b91c1c;
  padding: 2px 4px;
  font-size: 10px;
}


.d-label-and-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  padding: 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 2rem;
}

.d-label-and-toggle label {
  cursor: pointer;
}

.d-label-and-toggle:hover {
  background: aliceblue;
}

.prep-factor-input {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.prep-factor-input > input {
  width: 80px;
  text-align: center;
  background: #fff;
}

.color-dark {
  color: #222 !important;
}

.d-explainer-box {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.d-explainer-box .tw-icon {
  min-width: 24px;
}

.td-toggler {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// TaskOverviewSettingsSettings.vue?0b731cc0